import {createRouter, createWebHistory} from "vue-router"

const index = () => import("@/pages/index/index.vue");
const mine = () => import("@/pages/mine/mine.vue");
const auth = () => import("@/pages/auth/auth.vue");
const login = () => import("@/pages/auth/login.vue");
const userInfo = () => import("@/pages/mine/userInfo.vue");
const myBalance = () => import("@/pages/mine/myBalance.vue");
const myDraw = () => import("@/pages/mine/myDraw.vue");
const myWallet = () => import("@/pages/mine/myWallet.vue");
const myInvite = () => import("@/pages/mine/myInvite.vue");
const vip = () => import("@/pages/vip/vip")
const order = () => import("@/pages/order/order")
const orderInfo = () => import("@/pages/order/orderInfo")
const cabinet = () => import("@/pages/cabinet/cabinet")
const takeCab = () => import("@/pages/cabinet/takeCab")
const saveCab = () => import("@/pages/cabinet/saveCab")
const openCab = () => import("@/pages/cabinet/openCab")
const deviceAsset = () => import("@/pages/index/deviceAsset.vue")
const deviceGridInfo = () => import("@/pages/index/deviceGridInfo.vue")
const qrcode = () => import("@/pages/order/qrcode.vue")
const aiGuide = () => import("@/pages/ai/aiGuide.vue")



const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/takeCab',
        name: 'takeCab',
        component: takeCab
    },
    {
        path: '/saveCab',
        name: 'saveCab',
        component: saveCab
    },
    {
        path: '/openCab',
        name: 'openCab',
        component: openCab
    },
    {
        path: '/mine',
        name: 'mine',
        component: mine
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: userInfo
    },
    {
        path: '/myBalance',
        name: 'myBalance',
        component: myBalance
    },
    {
        path: '/myDraw',
        name: 'myDraw',
        component: myDraw
    },
    {
        path: '/myWallet',
        name: 'myWallet',
        component: myWallet
    },
    {
        path: '/myInvite',
        name: 'myInvite',
        component: myInvite
    },
    {
        path: '/auth',
        name: 'auth',
        component: auth
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/vip',
        name: 'vip',
        component: vip
    },
    {
        path: '/order',
        name: 'order',
        component: order
    },
    {
        path: '/orderInfo',
        name: 'orderInfo',
        component: orderInfo
    },
    {
        path: '/cabinet',
        name: 'cabinet',
        component: cabinet
    },
    {
        path: '/deviceAsset',
        name: 'deviceAsset',
        component: deviceAsset
    },
    {
        path: '/deviceGridInfo',
        name: 'deviceGridInfo',
        component: deviceGridInfo
    },
    {
        path: '/qrcode/:param',
        name: 'qrcode',
        component: qrcode
    },
    {
        path: '/aiGuide',
        name: 'aiGuide',
        component: aiGuide
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes: routes
});


// router.beforeEach((to, from, next) => {
//     if (to.path === '/login'
//         || to.path === '/qrcode') {
//         // 登录或者注册才可以往下进行
//         next();
//     } else {
//         // 获取 token
//         const userId = localStorage.getItem('userId');
//         // token 不存在
//         if (userId === null || userId === '') {
//             next('/login');
//         } else {
//             next();
//         }
//     }
// });


export default router;
